import { render, staticRenderFns } from "./JoinChat.vue?vue&type=template&id=cc001022&scoped=true&"
import script from "./JoinChat.vue?vue&type=script&lang=js&"
export * from "./JoinChat.vue?vue&type=script&lang=js&"
import style0 from "./JoinChat.vue?vue&type=style&index=0&id=cc001022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc001022",
  null
  
)

export default component.exports